define('drops/multiSelect/dropDownMultiSelect',[
    'jquery',
    'underscore',
    'lq/style',
    './dropdownitem'
], function ($, _, Style, DropDownItem) {
    'use strict';

    var arrowDownKey = 40;
    var arrowUpKey = 38;

    var DropDownMultiSelect = function (drop) {
        this.drop = drop;
        this.$el = $('<div />');
        this.$list = $('<div />');
        this.togglePlaceholder(true);
    };

    DropDownMultiSelect.prototype.render = function () {
        this.$el
            .addClass('multi-drop-down collapsed');

        this.$label = $('<div />')
            .addClass('multi-drop-down-label');

        var self = this;

        if (!this.drop.data.readOnly) {
            this.$button = $('<div />')
                .addClass('multi-drop-down-button')
                .attr('tabindex', this.drop.data.tabIndex)
                .on('keydown', function (e) {
                    if (e.which === arrowDownKey && !self.isOpen()) {
                        self.open();
                        e.preventDefault();
                    } else if (e.which === arrowUpKey && self.isOpen()) {
                        self.close();
                        e.preventDefault();
                    }
                });

            this.$el
                .on('click', function () {
                    if (self.isOpen())
                        self.close();
                    else
                        self.open();
                });
        }

        this.$el
            .append(this.$label, this.$button)
            .appendTo(this.drop.$element);

        this.$list
            .hide()
            .addClass('multi-drop-down-list')
            .appendTo(this.drop.piping.$app);

        if (this.drop.data.gridStyleId)
            this.$list.addClass(this.getGridStyleClassName());

        this.onClicked = this.handleClickOnDocument.bind(this);
        this.onScrolled = this.scrolledInApp.bind(this);

        $(document).on('click', this.onClicked);
        this.drop.piping.$actionWrapper.on('scroll', this.onScrolled);
    };

    DropDownMultiSelect.prototype.handleClickOnDocument = function (e) {
        if (!this.isOpen())
            return;

        var targetWasNotThisDrop = $(e.target).closest(this.drop.$element).length === 0;
        var targetWasNotThisList = $(e.target).closest(this.$list).length === 0;

        if (targetWasNotThisDrop && targetWasNotThisList)
            this.close();
    };

    DropDownMultiSelect.prototype.scrolledInApp = function() {
        this.$list.hide();
    };

    DropDownMultiSelect.prototype.getGridStyleClassName = function () {
        return Style.getClassNameFromStyleId('gridstyle-', this.drop.data.gridStyleId);
    };

    DropDownMultiSelect.prototype.isOpen = function () {
        return this.$list.is(':visible');
    };

    DropDownMultiSelect.prototype.open = function () {
        this.$el
            .removeClass('collapsed')
            .addClass('expanded');

        var $parent = this.drop.$element;
        var $app = this.drop.piping.$app;
        var top = $parent.offset().top - $app.offset().top + $parent.outerHeight();
        var left = $parent.offset().left - $app.offset().left;

        var maxHeight = $app.height() - top;

        this.$list
            .css({
                top: top,
                left: left,
                maxHeight: (maxHeight > 100 ? maxHeight : '100') + 'px',
                width: $parent.outerWidth(),
                zIndex: 7001
            })
            .show();
    };

    DropDownMultiSelect.prototype.close = function () {
        this.$el
            .removeClass('expanded')
            .addClass('collapsed');
        this.$list.hide();
        this.drop.triggerEventIfEnabled('collapsed');
    };

    DropDownMultiSelect.prototype.updateRequiredIndicator = function() {
        this.drop.updateRequiredIndicator();
    };

    DropDownMultiSelect.prototype.triggerEventIfEnabled = function (eventName, eventArg) {
        this.drop.triggerEventIfEnabled(eventName, eventArg);
    };

    DropDownMultiSelect.prototype.setItems = function (items, columns) {
        this.$list.empty();

        var self = this;

        if (this.drop.data.addAllOption) {
            var id = _.uniqueId('select_all_');
            this.$list.append($('<div />')
                .append($('<input type="checkbox" id="' + id + '" />')
                    .prop('checked', this.drop.data.selectAllByDefault)
                    .on('change', function () {
                        var $this = $(this);

                        if ($this.prop('checked'))
                            self.selectAll();
                        else
                            self.clear();
                    }))
                .append($('<label for="' + id + '" />').text(this.drop.data.allOptionLabel)));
        }

        columns = _.difference(columns, _.union(this.drop.data.hiddenColumns, [ this.drop.data.idOutput ]));

        // using <table /> because we are reusing the Grid styles here
        var $table = $('<table />');

        if (columns.length > 1) {
            var $checkboxHeader = $('<th />')
                .addClass('checkbox-column')
                .addClass('gridHeader');

            var $headers = _.map(columns, function (column) {
                return $('<th />')
                    .addClass('gridHeader')
                    .text(column);
            });
            $table.append($('<tr />')
                .append($checkboxHeader)
                .append($headers));
        }

        var textOutput = columns[0];
        var idOutput = this.drop.data.idOutput;

        this.rows = _.map(items, function (item) {
            var row = new DropDownItem(self, item[idOutput], item[textOutput], self.drop.selectAllByDefault);

            row.addExtraColumns(_.map(columns, function (column) {
                return item[column];
            }));

            return row;
        });

        if (this.drop.data.selectAllByDefault) {
            this.selectAll();
        }

        var $rows = _.pluck(this.rows, '$element');
        $table.append($rows);

        this.$list.append($table);

        this.updateUi();
    };

    DropDownMultiSelect.prototype.clear = function () {
        _.each(this.rows, function(row) {
            row.uncheck();
        });
    };

    DropDownMultiSelect.prototype.selectAll = function () {
        _.each(this.rows, function (row) {
            row.check();
        });
    };

    DropDownMultiSelect.prototype.setValue = function (selection) {
        this.selection = selection;
        this.updateUi();
    };

    DropDownMultiSelect.prototype.updateUi = function () {
        if (!this.selection)
            return;

        var self = this;
        _.each(this.rows, function (row) {
            var selected = self.selection.indexOf(row.id) !== -1;
            if (selected)
                row.check();
            else
                row.uncheck();
        });
    };

    DropDownMultiSelect.prototype.updateSummary = function () {
        var selectNames = _.chain(this.rows)
            .where({ checked: true })
            .pluck('label')
            .value();
        var summary = selectNames.join(', ');

        this.togglePlaceholder(!summary);
        this.$label.text(summary);
    };

    DropDownMultiSelect.prototype.getValue = function () {
        return _.chain(this.rows)
            .where({ checked: true })
            .pluck('id')
            .value();
    };

    DropDownMultiSelect.prototype.togglePlaceholder = function (isVisible) {
        var placeholder = isVisible ? this.drop.data.placeholder : "";
        this.$el.text(placeholder)

        this.$el
            .append(this.$label, this.$button)
    };

    DropDownMultiSelect.prototype.dispose = function () {
        this.$list.remove();
        $(document).off('click', this.onClicked);
        this.drop.piping.$actionWrapper.off('scroll', this.onScrolled);
    };

    return DropDownMultiSelect;
});
